import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const contractTypeFields = [
  "gaming_contracttypeid", // UID
  "gaming_name", // Text
  "gaming_relatedcountry", // Reference
  "gaming_requiredforedsordering", // Choice
] as const;

export const contractTypeReferences: EntityReferences<EntityName.gaming_contracttype> = {
  [EntityName.ggp_country]: ["gaming_relatedcountry"],
};

export const contractTypeKey: AnyEntityField<EntityName.gaming_contracttype> =
  "gaming_contracttypeid";
